import { FormattedMessage, useIntl } from 'react-intl'
import Button from '@/shared/ui/Button';
import { IconSearch } from '@/shared/ui/Icons';
import Select from "@/shared/ui/Select";
import Input from "@/shared/ui/Input";
import FieldWrapper from "@/shared/ui/FieldWrapper";
import Multiselect from "@/shared/ui/Multiselect";
import { useForm, Controller } from 'react-hook-form';
import { FILTER_SIGN_OPTIONS, FILTER_STATUS } from './constants/filter';
import type { WorkersFiltersProps } from './WorkersFilters';
import s from "./WorkersFilter.module.scss";

const WorkersFiltersContent = (props: WorkersFiltersProps) => {
  const { 
    values = {},
    onApply = () => {},
    onClear = () => {},
  } = props;
  const intl = useIntl();

  const methods = useForm({
    values,
  });
  const {
    handleSubmit,
    register,
    reset,
  } = methods;

  const multiSelectItems = [
    { value: FILTER_STATUS.ONLINE, label: intl.formatMessage({id: 'workers.online'})},
    { value: FILTER_STATUS.OFFLINE, label: intl.formatMessage({id: 'workers.offline'})},
    { value: FILTER_STATUS.WITH_ISSSUES, label: intl.formatMessage({id: 'workers.withIssues'})},
  ];

  const handleOnSubmit = (data: any) => {
    onApply(data);
  }

  return (
    <form onSubmit={handleSubmit(handleOnSubmit)}>
      <Input
        {...register('search')}
        prefix={<IconSearch className="text-white" />}
        placeholder={intl.formatMessage({id: 'filter.worker.name'})}
        className="mb-4"
        full
      />
      <Multiselect
        {...register('status')}
        label={intl.formatMessage({id: 'filter.worker.status'})}
        className="mb-4"
        full={true}
        items={multiSelectItems}
      />

      <FieldWrapper 
        label={intl.formatMessage({id: 'Hashrate'})}
        full={true} 
        className="mb-4"
      >
        <div className="flex items-center">
          <div className="w-[30px]">
            <Controller
              control={methods.control}
              defaultValue={FILTER_SIGN_OPTIONS[0].value}
              name="hashrateSign"
              render={({
                field: { onChange, value, ref },
              }) => (
                <Select
                  menuPlacement='auto'
                  inputRef={ref}
                  showDropdownIndicator={false}
                  isCenter={true}
                  full={true}
                  controlClassName={s.selectControl}
                  options={FILTER_SIGN_OPTIONS}
                  value={FILTER_SIGN_OPTIONS.find(c => c.value === value)}
                  onChange={val => onChange(val.value)}
                />
              )}
            />
          </div>
          <div className="flex-grow ml-2">
            <Input
              placeholder={0}
              defaultValue={0}
              type="number"
              step="0.1"
              min="0"
              full
              {...register('hashrate', { valueAsNumber: true })}
            />
          </div>
        </div>
      </FieldWrapper>

      <FieldWrapper 
        label={intl.formatMessage({id: 'worker.stale.shares'})}
        full={true} 
        className="mb-4"
      >
        <div className="flex items-center">
          <div className="w-[30px]">
            <Controller
              control={methods.control}
              defaultValue={FILTER_SIGN_OPTIONS[0].value}
              name="sharesStaleSign"
              render={({
                field: { onChange, value, ref },
              }) => (
                <Select
                  menuPlacement='top'
                  inputRef={ref}
                  showDropdownIndicator={false}
                  isCenter={true}
                  full={true}
                  controlClassName={s.selectControl}
                  options={FILTER_SIGN_OPTIONS}
                  value={FILTER_SIGN_OPTIONS.find(c => c.value === value)}
                  onChange={val => onChange(val.value)}
                />
              )}
            />
          </div>
          <div className="flex-grow ml-2">
            <Input
              placeholder={0}
              defaultValue={0}
              step="1"
              min="0"
              type="number"
              full
              {...register('sharesStale', { valueAsNumber: true })}
            />
          </div>
        </div>
      </FieldWrapper>

      <FieldWrapper 
        label={intl.formatMessage({id: 'worker.invalid.shares'})}
        full={true} 
        className="mb-4"
      >
        <div className="flex items-center">
          <div className="w-[30px]">
            <Controller
              control={methods.control}
              defaultValue={FILTER_SIGN_OPTIONS[0].value}
              name="sharesInvalidSign"
              render={({
                field: { onChange, value, ref },
              }) => (
                <Select
                  menuPlacement='top'
                  selectClassName="text-select"
                  inputRef={ref}
                  showDropdownIndicator={false}
                  controlClassName={s.selectControl}
                  isCenter={true}
                  full={true}
                  options={FILTER_SIGN_OPTIONS}
                  value={FILTER_SIGN_OPTIONS.find(c => c.value === value)}
                  onChange={val => onChange(val.value)}
                />
              )}
            />
          </div>
          <div className="flex-grow ml-2">
            <Input
              placeholder={0}
              defaultValue={0}
              step="1"
              min="0"
              type="number"
              full
              {...register('sharesInvalid', { valueAsNumber: true })}
            />
          </div>
        </div>
      </FieldWrapper>

      <div className="flex -mx-1">
        <Button 
          type="button"
          onClick={() => {
            if (typeof onClear === 'function') {
              onClear();
            }
            reset();
          }}
          className="w-1/2 mx-1"
        >
          <FormattedMessage id="clear"/>
        </Button>
        <Button
          type="submit"
          className="w-1/2 mx-1" 
          colorSchema="primary"
        >
          <FormattedMessage id="apply"/>
        </Button>
      </div>
    </form>
  );
}

export default WorkersFiltersContent;
